<!-- Marketplace feed (mobile) -->
<a class="fmp mpf" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
  <div class="mpf-header">
    <img class="mpf-avatar" [src]="avatar" alt="" />
    <div class="mpf-identity">
      <div class="fmp-ellipsis mpf-name">{{ pageName }}</div>
      <div class="mpf-label">Sponsored</div>
    </div>
    <i class="bi bi-three-dots mpf-menu"></i>
  </div>
  <app-meta-creative class="fmp-image mpf-image" [src]="data.creative" [kind]="data.creativeKind" slot="cover"></app-meta-creative>
  <div class="fmp-ellipsis mpf-headline">{{ headline }}</div>
</a>
